<template>

	<div class="main-dashboard-area">
		<div class="container">
			<div class="row">
				<div class="col-12">

					<div style="margin: auto;">
						<div style="font-size: 20px; text-align: center;" class="alert"
							:class="{ 'alert-danger': n.is_important == 'y', 'alert-info': n.is_important == 'n' }"
							v-for="n in notifications" :key="n">
							<div style="float: right; cursor: pointer; font-weight: bold;"
								class="btn btn-primary btn-sm" @click="seeNotification(n)">OK</div>
							{{ n.message }}
						</div>
					</div>

				</div>
			</div>
		</div>

		<div class="text-center" style="font-size: 22px; font-weight: bold; color: #444;">
			<a class="pull-right text-info" href="https://www.youtube.com/watch?v=MvCVoDtg9lI" target="_blank"
				style="font-size: 20px; margin-top: 5px; margin-right: 15px; text-decoration: none;">
				<i style="color: #ff0000" class="fa fa-youtube-play"></i> Help
			</a>
			<a class="pull-right text-primary" href="https://teleradio.in/dicomsetup.zip" target="_blank"
				style="font-size: 20px; margin-top: 5px; margin-right: 15px; text-decoration: none;">
				<i class="fa-solid fa-download"></i> DICOM Setup
			</a>
			<div class="pull-right"
				:class="{ 'text-success': bages.reviewPercent <= 2, 'text-warning': bages.reviewPercent > 2 && bages.reviewPercent <= 3, 'text-danger': bages.reviewPercent > 3 }"
				style="margin-right: 36px; font-size: 20px; margin-top: 5px;">
				Review: {{ bages.reviewPercent }}%
			</div>
			Welcome to {{ bages.centerName }} (Center ID: {{ bages.centerId }})
		</div>
		<div style="height: 20px;"></div>
		<div class="container-fluid first-badge-section">
			<div class="row">

				<div @click="$router.push('/center/xray-report')" class="col-sm-6 col-lg-3">
					<div class="card text-white bg-info top-stat-card xray-card">
						<div class="card-body">
							<div class="text-value">{{ bages.xray_reports }}</div>
							<div>Number of XRay case today</div>
						</div>
					</div>
				</div>
				<div @click="$router.push('/center/ecg-report')" class="col-sm-6 col-lg-3">
					<div class="card text-white bg-primary top-stat-card ecg-card">
						<div class="card-body">
							<div class="text-value">{{ bages.ecg_reports }}</div>
							<div>Number of ECG case today</div>
						</div>
					</div>
				</div>
				<div @click="$router.push('/center/payment')" class="col-sm-6 col-lg-3">
					<div class="card text-white top-stat-card money-card"
						:class="{ 'bg-danger': 'balance' in bages && bages.balance <= 300, 'bg-success': bages.balance > 300 }">
						<div class="card-body clearfix">
							<button v-if="'balance' in bages && bages.balance <= 300" type="button"
								class="btn btn-info btn-sm pull-right"><i class="fa fa-arrow-right"></i> Recharge
								Now</button>
							<div class="text-value">&#8377;{{ bages.balance }}</div>
							<div>Balance Amount</div>
						</div>
					</div>
				</div>
				<div class="col-sm-6 col-lg-3">
					<div class="card text-white bg-warning top-stat-card calendar-card">
						<div class="card-body">
							<div class="text-value">&#8377;{{ bages.last_payment?.amount }} <span
									v-if="bages.last_payment?.date">({{ format(bages.last_payment?.date, "DD/MM/YY")
									}})</span>
							</div>
							<div>Last recharge</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container-fluid" style="margin-top: 15px;">
			<div class="row">
				<div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 second-badge-section">
					<canvas id="myChart"></canvas>
					<h5 class="text-secondary text-center" style="padding-top: 10px;">Report Volume</h5>
				</div>
				<div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 second-badge-section" >
					<canvas id="qualityChart"></canvas>
					<h5 class="text-secondary text-center" style="padding-top: 10px;">Quality Chart</h5>
				</div>
				<div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 second-badge-section" >
					<canvas id="tatChart"></canvas>
					<h5 class="text-secondary text-center" style="padding-top: 10px;">TAT Chart</h5>
				</div>
				<div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" v-if="false">
					<a href="http://labsystem.in" target="_blank">
						<div style="position: absolute; padding: 1px">
							<div style="background: #ffcd09; color: rgb(255, 255, 255); padding: 0 5px;">Ads</div>
						</div>
						<img style="display: block; width: 100%;" :src="adsImage" alt="">
					</a>
				</div>
			</div>
		</div>
		<div class="container-fluid" style="margin-top: 15px;">
			<div class="row">
				<div class="col-lg-8 col-md-12 col-sm-12 col-xs-12 second-badge-section">
					<canvas id="xray12MonthChart"></canvas>
					<h5 class="text-secondary text-center" style="padding-top: 10px;">Xray Reports (Last 12 Months)</h5>
				</div>
				<div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 second-badge-section">
					<canvas id="xrayCaseRatioChart"></canvas>
					<h5 class="text-secondary text-center" style="padding-top: 10px;">Single/Double/Special Ratio</h5>
				</div>
			</div>
		</div>
		<div class="third-badge-section">
			<div class="text-center" style="font-size: 20px; font-weight: bold; color: #000;">
				Radiologists
			</div>
			<table class="table table-striped">
				<thead>
					<tr>
						<th>Dr Name</th>
						<th>Degree</th>
						<th>Reg No</th>
						<th>Experience</th>
						<th>Accuracy Rate</th>
						<th>Average T.A.T</th>
						<th>Average Rating</th>
						<th>Your Rating</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="d in doctors" :key="d">
						<th>{{ d.name }}</th>
						<td>{{ d.degree }}</td>
						<td>{{ d.registration_no }}</td>
						<td>{{ d.experience }}</td>
						<td>{{ shrinkDecimal(d.accuracy) }}%</td>
						<td>{{ msToMins(d.tat) }}</td>
						<td>
							<div class="star-rating-wrapper">
								<div class="stars-outer">
									<i v-for="star in 5" :key="'empty-' + star"
										class="fa fa-star fa-regular text-secondary" :title="d.average_rating"></i>
									<div class="stars-inner" :style="{ width: (d.average_rating / 5 * 100) + '%' }">
										<i v-for="star in 5" :key="'fill-' + star"
											class="fa fa-star fa-solid text-warning"></i>
									</div>
								</div>
							</div>
						</td>
						<td>
							<div class="star-rating">
								<i v-for="star in 5" :key="star" class="fa-star" :class="[
									'fa',
									star <= (hoverRatings[d.id] || getMyRating(d)) ? 'fa-solid text-warning' : 'fa-regular text-secondary'
								]" @mouseover="hoverRatings[d.id] = star" @mouseleave="hoverRatings[d.id] = 0" @click="giveRatings(d, star)"
									style="cursor: pointer; font-size: 20px; margin-right: 3px;"></i>
							</div>
						</td>

					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			hoverRatings: {},
			centerId: JSON.parse(localStorage.getItem("center_access_token")).id,
			bages: {},
			notifications: [],

			adsImage: '',

			quality: null,
			tat: null,
			xray12Month: [],
			xrayCaseRatio: {
				single: 0,
				double: 0,
				special: 0,
				total: 0,
			},
			doctors: [],

			qualityChart: null,
			tatChart: null,
			xray12MonthChart: null,
			xrayCaseRatioChart: null,
		}
	},
	async created() {
		this.bages = await this.get("center/dashboard-bages");

		if (this.bages.center_ads) this.adsImage = window.apiOrigin + '/images/center/' + this.bages.center_ads;
	},
	async mounted() {
		let getDate = (adjust) => {
			let time = new Date();
			time.setTime(time.getTime() + adjust * 24 * 60 * 60 * 1000);

			let day = this.format(time, "dddd");

			let date = this.format(time, "YYYY-MM-DD");
			date = new Date(date);
			date.setTime(date.getTime() - 5.5 * 60 * 60 * 1000);
			let start = date.toISOString();

			time = new Date();
			time.setTime(time.getTime() + (adjust + 1) * 24 * 60 * 60 * 1000);
			date = this.format(time, "YYYY-MM-DD");
			date = new Date(date);
			date.setTime(date.getTime() - 5.5 * 60 * 60 * 1000);
			let end = date.toISOString();

			return {
				start,
				end,
				day
			}
		}
		let dates = [];
		for (let i = 0; i < 7; i++) {
			dates.unshift(getDate(i * -1));
		}

		let res = await this.post('center/load-xray-reports-graph-data', {
			dates,
		});

		let data = res.dates;
		this.quality = res.quality;
		this.tat = res.tat;
		this.xray12Month = Array.isArray(res.xray12Month) ? res.xray12Month : [];
		this.xrayCaseRatio = res.xrayCaseRatio || {
			single: 0,
			double: 0,
			special: 0,
			total: 0,
		};
		const filterDoctor = res.doctors;
		this.doctors = filterDoctor.filter(doc => doc.active === true)
		this.doctors.sort((a, b) => {
			return parseFloat(b.average_rating) - parseFloat(a.average_rating);
		});

		var xValues = [];//"Italy", "France", "Spain", "USA", "Argentina", "sdlkj", "ksdj"
		var yValues = [];//55, 49, 44, 24, 30, 60, 90
		for (let date of data) {
			xValues.push(date.day);
			yValues.push(date.data);
		}


		var barColors = ["red", "green", "blue", "orange", "brown", "#60ccf0", "#1e5373"];

		new window.Chart("myChart", {
			type: "bar",
			data: {
				labels: xValues,
				datasets: [{
					backgroundColor: barColors,
					data: yValues
				}]
			},
				options: {
					legend: { display: false },
					title: {
						display: true,
						text: "Reports"
					}
				}
			});
		this.syncNewChartsHeightWithTopRow();

		this.notifications = await this.get('center/load-unseen-notifications');

		this.showQualityChart();
		this.showTatChart();
		this.showXray12MonthChart();
		this.showXrayCaseRatioChart();


	},
	methods: {

		getMyRating(doctor) {
			if (!doctor.rating) return 0;
			if (doctor.rating.center_id === this.centerId) {
				return doctor.rating.rating;
			}
			return 0;
		},

		async giveRatings(doctor, rating) {
			try {
				// Immediately reflect in UI
				let existing = doctor.ratings?.find(r => r.center_id === this.centerId);
				if (existing) existing.rating = rating;
				else {
					if (!doctor.ratings) doctor.ratings = [];
					doctor.ratings.push({ center_id: this.centerId, rating });
				}

				// Send to server
				await this.post('center/give-doctor-rating', {
					center_id: this.centerId,
					doctor_id: doctor.id,
					rating
				});

				let getDate = (adjust) => {
					let time = new Date();
					time.setTime(time.getTime() + adjust * 24 * 60 * 60 * 1000);

					let day = this.format(time, "dddd");

					let date = this.format(time, "YYYY-MM-DD");
					date = new Date(date);
					date.setTime(date.getTime() - 5.5 * 60 * 60 * 1000);
					let start = date.toISOString();

					time = new Date();
					time.setTime(time.getTime() + (adjust + 1) * 24 * 60 * 60 * 1000);
					date = this.format(time, "YYYY-MM-DD");
					date = new Date(date);
					date.setTime(date.getTime() - 5.5 * 60 * 60 * 1000);
					let end = date.toISOString();

					return {
						start,
						end,
						day
					}
				}
				let dates = [];
				for (let i = 0; i < 7; i++) {
					dates.unshift(getDate(i * -1));
				}

				let res = await this.post('center/load-xray-reports-graph-data', {
					dates,
				});


				const filterDoctor = res.doctors;
				this.doctors = filterDoctor.filter(doc => doc.active === true)

				this.doctors.sort((a, b) => {
					return parseFloat(b.average_rating) - parseFloat(a.average_rating);
				});
				this.$toast.add({ severity: 'success', summary: 'Success', detail: `You rated ${doctor.name} ${rating}⭐`, life: 3000 });


			} catch (err) {
				console.error(err);
				this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Error in saving', life: 3000 });
			}
		},
		msToMins(ms) {
			const totalMinutes = Math.floor(ms / 60000);
			if (totalMinutes === 0) return "NA";
			return `${String(totalMinutes).padStart(2, '0')} minutes`;
		},


		shrinkDecimal(val) {
			return Math.round((val) * 100) / 100;
		},
		async seeNotification(n) {
			let i = this.notifications.indexOf(n);
			this.notifications.splice(i, 1);
			await this.post('center/see-notification', {
				id: n.id
			});
		},
		showQualityChart() {
			let total = this.quality.accurate + this.quality.review + this.quality.substandard;

			let accuratePercent = Math.round((this.quality.accurate / total) * 100 * 100) / 100;
			let reviewPercent = Math.round((this.quality.review / total) * 100 * 100) / 100;
			let subPercent = Math.round((this.quality.substandard / total) * 100 * 100) / 100;
			if (!isFinite(accuratePercent)) accuratePercent = 0;
			if (!isFinite(reviewPercent)) reviewPercent = 0;
			if (!isFinite(subPercent)) subPercent = 0;

			let backgroundColor = ["#0d6efd", "orange", "gray"];
			let labels = [`Accurate (${accuratePercent}%)`, `Review (${reviewPercent}%)`, `Substandard (${subPercent}%)`];
			let data = [this.quality.accurate, this.quality.review, this.quality.substandard];

			if (this.qualityChart) this.qualityChart.destroy();

			this.qualityChart = new Chart("qualityChart", {
				type: 'pie',
				data: {
					labels,
					datasets: [
						{
							label: 'Report Quality',
							data,
							backgroundColor,
						}
					]
				},
				options: {
					responsive: true,
					plugins: {
						legend: {
							position: 'top',
						},
						title: {
							display: false,
							text: 'Report Quality'
						}
					}
				},
			});
		},
		showTatChart() {
			let total = this.tat.within15min + this.tat.within30min + this.tat.morethan30min;

			let within15minPercent = Math.round((this.tat.within15min / total) * 100 * 100) / 100;
			let within30minPercent = Math.round((this.tat.within30min / total) * 100 * 100) / 100;
			let morethan30minPercent = Math.round((this.tat.morethan30min / total) * 100 * 100) / 100;
			if (!isFinite(within15minPercent)) within15minPercent = 0;
			if (!isFinite(within30minPercent)) within30minPercent = 0;
			if (!isFinite(morethan30minPercent)) morethan30minPercent = 0;

			let backgroundColor = ["#06b6d4", "#f97316", "#7c3aed"];
			let labels = [`Within 15 min(${within15minPercent}%)`, `Within 30 min(${within30minPercent}%)`, `More Than 30 min(${morethan30minPercent}%)`];
			let data = [this.tat.within15min, this.tat.within30min, this.tat.morethan30min];

			if (this.tatChart) this.tatChart.destroy();

			this.tatChart = new Chart("tatChart", {
				type: 'pie',
				data: {
					labels,
					datasets: [
						{
							label: 'T.A.T',
							data,
							backgroundColor,
						}
					]
				},
				options: {
					responsive: true,
					plugins: {
						legend: {
							position: 'top',
						},
						title: {
							display: false,
							text: 'T.A.T'
						}
					}
				},
			});
		},
		syncNewChartsHeightWithTopRow() {
			let topChartCanvas = document.getElementById("myChart");
			if (!topChartCanvas) return;

			let topChartHeight = Math.round(topChartCanvas.getBoundingClientRect().height);
			if (!topChartHeight) return;

			let bottomChartIds = ["xray12MonthChart", "xrayCaseRatioChart"];
			for (let id of bottomChartIds) {
				let canvas = document.getElementById(id);
				if (!canvas) continue;
				canvas.style.height = topChartHeight + "px";
			}
		},
		showXray12MonthChart() {
			let labels = this.xray12Month.map(row => row.label);
			let data = this.xray12Month.map(row => Number(row.total || 0));
			let monthColors = [
				"#0d6efd",
				"#198754",
				"#fd7e14",
				"#6f42c1",
				"#dc3545",
				"#20c997",
				"#6610f2",
				"#0dcaf0",
				"#ffc107",
				"#d63384",
				"#6c757d",
				"#17a2b8",
			];
			let backgroundColor = data.map((_, i) => monthColors[i % monthColors.length]);

			if (this.xray12MonthChart) this.xray12MonthChart.destroy();

			this.xray12MonthChart = new Chart("xray12MonthChart", {
				type: 'bar',
				data: {
					labels,
					datasets: [{
						label: 'Xray Reports',
						backgroundColor,
						data
					}]
				},
				options: {
					responsive: true,
					maintainAspectRatio: false,
					plugins: {
						legend: { display: false },
						title: {
							display: true,
							text: 'Xray Reports (Last 12 Months)',
						}
					}
				},
			});
		},
		showXrayCaseRatioChart() {
			let single = Number(this.xrayCaseRatio.single || 0);
			let double = Number(this.xrayCaseRatio.double || 0);
			let special = Number(this.xrayCaseRatio.special || 0);
			let total = Number(this.xrayCaseRatio.total || (single + double + special));

			let singlePercent = Math.round((single / total) * 100 * 100) / 100;
			let doublePercent = Math.round((double / total) * 100 * 100) / 100;
			let specialPercent = Math.round((special / total) * 100 * 100) / 100;
			if (!isFinite(singlePercent)) singlePercent = 0;
			if (!isFinite(doublePercent)) doublePercent = 0;
			if (!isFinite(specialPercent)) specialPercent = 0;

			let labels = [
				`Single View (${singlePercent}%)`,
				`Double View (${doublePercent}%)`,
				`Special Case (${specialPercent}%)`
			];
			let data = [single, double, special];
			let backgroundColor = ["#0d6efd", "#198754", "#fd7e14"];

			if (this.xrayCaseRatioChart) this.xrayCaseRatioChart.destroy();

			this.xrayCaseRatioChart = new Chart("xrayCaseRatioChart", {
				type: 'doughnut',
				data: {
					labels,
					datasets: [{
						label: 'Single/Double/Special Ratio',
						data,
						backgroundColor,
					}]
				},
				options: {
					responsive: true,
					maintainAspectRatio: false,
					cutout: '50%',
					cutoutPercentage: 50,
					plugins: {
						datalabels: {
							display: total > 0,
							formatter: (value) => {
								let p = Math.round((value / total) * 100 * 100) / 100;
								if (!isFinite(p)) p = 0;
								return `${p}%`;
							},
							color: (ctx) => {
								let i = ctx.dataIndex;
								return i === 2 ? "#1f2937" : "#ffffff";
							},
							font: {
								weight: 'bold',
								size: 20,
							},
							textStrokeColor: 'rgba(0,0,0,0.35)',
							textStrokeWidth: 2,
							padding: 2,
							clamp: true,
							anchor: 'center',
							align: 'center',
						},
						legend: { position: 'top' },
						title: {
							display: true,
							text: 'Single/Double/Special Ratio',
						}
					},
					tooltips: {
						callbacks: {
							label: (tooltipItem, chartData) => {
								let value = Number(chartData.datasets[0].data[tooltipItem.index] || 0);
								let p = Math.round((value / total) * 100 * 100) / 100;
								if (!isFinite(p)) p = 0;
								return `${chartData.labels[tooltipItem.index]}: ${value} (${p}%)`;
							}
						}
					}
				},
			});
		},
	}
}
</script>
<style scoped>
.main-dashboard-area {
	padding: 15px;
	background-color: rgb(228, 228, 226);
}

.first-badge-section,
.second-badge-section,
.third-badge-section {
	background-color: #FFFFFF;
	border-radius: 10px;
	border: 1px solid rgb(214, 214, 214);
}

.first-badge-section {
	padding: 15px;
	margin-right: 10px;
}


.third-badge-section {
	padding: 35px 10px 0px 10px;
	margin-top: 15px;
}

.card-body {
	flex: 1 1 auto;
	padding: 1.25rem;
}

.top-stat-card {
	position: relative;
	overflow: hidden;
}

.top-stat-card::after {
	content: "";
	position: absolute;
	right: 10px;
	top: 50%;
	width: 92px;
	height: 92px;
	transform: translateY(-50%);
	background-image: var(--card-bg);
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	opacity: 0.28;
	pointer-events: none;
}

.top-stat-card .card-body {
	position: relative;
	z-index: 1;
}

.xray-card {
	--card-bg: url('/fimg/xray.png');
}

.ecg-card {
	--card-bg: url('/fw/fa6/svgs/solid/heart-pulse.svg');
}

.money-card {
	--card-bg: url('/fw/fa6/svgs/solid/wallet.svg');
}

.calendar-card {
	--card-bg: url('/fw/fa6/svgs/solid/calendar-days.svg');
}

.text-value {
	font-size: 1.3125rem;
	font-weight: 600;
}

.star-rating {
	display: inline-block;
}

.fa-star {
	transition: color 0.2s ease;
}

.star-rating-wrapper {
	display: inline-block;
	position: relative;
	font-size: 20px;
}

.stars-outer {
	position: relative;
	display: inline-block;
	color: #dcdcdc;
	/* fallback empty star color */
}

.stars-inner {
	position: absolute;
	top: 0;
	left: 0;
	white-space: nowrap;
	overflow: hidden;
	color: #ffc107;
	/* filled star color */
	pointer-events: none;
	/* unclickable */
}
</style>
